var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54,12H32a6.0066,6.0066,0,0,0-6,6v2H10a6.0066,6.0066,0,0,0-6,6V40a6.0066,6.0066,0,0,0,6,6v4a2,2,0,0,0,3.1006,1.67L21.7051,46H32a6.0066,6.0066,0,0,0,6-6V38h4.3252l8.5713,5.6685A2,2,0,0,0,54,42V38a6.0066,6.0066,0,0,0,6-6V18A6.0066,6.0066,0,0,0,54,12ZM34,40a2.0023,2.0023,0,0,1-2,2H21.1055a1.9994,1.9994,0,0,0-1.1006.33L14,46.2871V44a2,2,0,0,0-2-2H10a2.0023,2.0023,0,0,1-2-2V26a2.0023,2.0023,0,0,1,2-2H32a2.0023,2.0023,0,0,1,2,2V40Zm22-8a2.0023,2.0023,0,0,1-2,2H52a2,2,0,0,0-2,2v2.28l-5.97-3.9483A2.001,2.001,0,0,0,42.9268,34H38V26a6.0066,6.0066,0,0,0-6-6H30V18a2.0023,2.0023,0,0,1,2-2H54a2.0023,2.0023,0,0,1,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.02,31h-.01a2.0049,2.0049,0,1,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.02,31h-.01a2.0049,2.0049,0,1,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.02,31h-.01a2.0049,2.0049,0,1,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.02,23h-.01a2.0049,2.0049,0,1,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.02,23h-.01a2.0049,2.0049,0,1,0,.01,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.e4eee5790ba3f9e60fdc40d7d4cffb98.svg";
export { ForwardRef as ReactComponent };